import { CreateUpdateRoleRequest } from '@src/main/modules/roles/infrastructure/dto/createUpdateUserRequest';
import { createRoleHttpRepository } from '@src/main/modules/roles/infrastructure/RoleHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateRoleUseCase = async (
  id: string,
  data: CreateUpdateRoleRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createRoleHttpRepository(tokenProvider);
  return await repository.update(id, data);
};
